import React from "react";
import {ISvgIconProps, SvgIcon} from "./svg-icon.component";

export const CheckboxUncheckedIcon: React.FC<ISvgIconProps> = (props) => {
    return (
        <SvgIcon size={1.4} fill={"none"} {...props} viewBox="0 0 24 24" ratio={1}>
            <path
                d="M20.1317 20.1317C17.9751 22.2884 15.05 23.5 12 23.5C8.95001 23.5 6.02494 22.2884 3.86827 20.1317C1.7116 17.9751 0.5 15.05 0.5 12C0.5 8.95001 1.7116 6.02494 3.86827 3.86827C6.02494 1.7116 8.95001 0.5 12 0.5C15.05 0.5 17.9751 1.7116 20.1317 3.86827C22.2884 6.02494 23.5 8.95001 23.5 12C23.5 15.05 22.2884 17.9751 20.1317 20.1317Z"
                stroke="#102930"/>
        </SvgIcon>
    )
}
